import { Outlet } from 'react-router-dom'

/**
 * Wraps default (client) routes and applies REF theme.
 * Import ref-theme.css here so it only applies when this layout is mounted.
 */
export default function ClientLayout() {
  return <Outlet />
}
